// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__13iFa","header":"PatientQuestionnaire_header__NMrzo","info":"PatientQuestionnaire_info__4cawU"};